<template>
  <Layout v-if="$data.isReady">
    <Navbar />
    <Header class="sub-header" style="position:fixed; width:100%; z-index:2; margin-top:64px;">
      <div class="sub-header-items">
        <Icon
          v-if="userRole == 'manager'"
          @click.native="collapsedSider"
          :style="{margin: '16px 20px', position: 'absolute'}"
          type="ios-menu"
          size="24"
        ></Icon>
        <h4 style="text-align:center;">{{webcast.title}}</h4>
      </div>
    </Header>
    <Layout style="margin-top:64px;">
      <Sider
        ref="side1"
        :defaultCollapsed="siderDefaultCollapsed"
        collapsed-width="0"
        hide-trigger
        collapsible
        v-model="isCollapsed"
        width="240"
        style="position:fixed; padding-top:56px; height:100%;
      overflow: scroll;"
      >
        <WebcastDetailMenu />
      </Sider>
      <Content :class="{siderOpen: !isCollapsed}">
        <router-view></router-view>
      </Content>
    </Layout>
  </Layout>
</template>

<script>
import WebcastDetailMenu from "@/components/webcast/WebcastDetailMenu.vue";
import Navbar from "@/components/base/Navbar.vue";
import feathersClient from "../../api/feathers-client";
import { mapState, mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      isReady: false,
      isCollapsed: true,
      siderDefaultCollapsed: false,
      userRole: null
    };
  },
  computed: {
    ...mapGetters("webcast", {
      webcast: "getCopy"
    })
  },
  components: {
    WebcastDetailMenu,
    Navbar
  },
  methods: {
    
    ...mapActions("current", {
      setCurrent: "set"
    }),
    ...mapActions("webcast", {
      getWebcast: "get"
    }),
    ...mapActions("audio-room", {
      getAudioRoom: "get"
    }),
    ...mapActions("user-permissions", {
      findPermission: "find"
    }),
    ...mapActions("page-settings", {
      getPageSettings: "find",
      createPageSettings: "create"
    }),
    collapsedSider() {
      this.$refs.side1.toggleCollapse();
    },
    async checkUserRole() {
      if (this.$store.state.auth.user.role != "admin") {
        await this.findPermission({
          query: {
            userId: this.$store.state.auth.user._id,
            accountId: this.webcast.accountId
          }
        }).then(res => {
          if (res.total <= 0) {
            this.userRole = "denied";
            this.$router.replace("/403");
          }

          if (res.data[0].role != "manager") {
            if (this.isCollapsed == false) {
              //this.collapsedSider();
              this.isCollapsed = true;
            }
            this.userRole = "moderator";
            this.$router.replace("/wc/" + this.webcast._id + "/qna");
          } else {
            if (this.isCollapsed == false) {
              this.isCollapsed = true;
            }
            this.userRole = "manager";
          }
        });
      } else {
        if (this.isCollapsed == true) {
          this.isCollapsed = false;
        }
        this.userRole = "manager";
      }
    }
  },
  async created() {
    this.$data.isReady = false;
    this.$store.commit("webcast/clearAll");
    this.$store.commit("stream/clearAll");
    this.$store.commit("qna/clearAll");
    this.$store.commit("reg-form/clearAll");
    this.$store.commit("registrations/clearAll");
    this.$store.commit("attendees/clearAll");
    this.$store.commit("page-settings/clearAll");
    this.$store.commit("landing-content/clearAll");
    this.$store.commit("webcast-session/clearAll");
    this.$store.commit("realtime-stats/clearAll");
    this.$store.commit("widgets/clearAll");
    this.$store.commit("agg-connections/clearAll");

    await this.getWebcast(this.$router.currentRoute.params.id).then(wc => {
      this.$store.commit("webcast/setCurrent", wc._id);
      this.setCurrent({
        service: "webcast",
        id: wc._id
      });
    });

    this.checkUserRole();

    if (this.webcast.hasAudioRoom) {
      console.log(this.webcast.audioRoomId);
      this.getAudioRoom(this.webcast.audioRoomId).then(audioRoom => {
        console.log(audioRoom);
      });
    }

    await this.getPageSettings({
      query: {
        webcastId: this.webcast._id
      }
    }).then(response => {
      if (response.total <= 0) {
        this.createPageSettings({ webcastId: this.webcast._id }).then(resp => {
          this.$store.commit("page-settings/setCurrent", resp._id);
        });
      } else {
        this.$store.commit("page-settings/setCurrent", response.data[0]._id);
      }
      this.$data.isReady = true;
    });

    let self = this;
    feathersClient.io.on("connect", function() {
      if (self.$store.state.webcast.copy) {
        self.getWebcast(self.$router.currentRoute.params.id).then(wc => {
          console.log("webcast reloaded");
          self.$store.commit("webcast/setCurrent", wc._id);
          self.setCurrent({
        service: "webcast",
        id: wc._id
      });
        });
      }
    });
  }
};
</script>

<style>
.collapsed-menu i {
}
.ivu-layout-content {
  transition: padding 0.2s ease 0.2s, transform 0.2s ease 0.2s;
}
.siderOpen {
  padding-left: 240px;
}
</style>
